export const SET_USERS = 'SET_USERS';
export const ADD_USERS = 'ADD_USERS';
export const SET_USERS_TOTAL_COUNT = 'SET_USERS_TOTAL_COUNT';
export const SET_USERS_LOADING = 'SET_USERS_LOADING';
